

    <div *ngFor="let liveAir of liveAirs " class=" liveAir" >
        <div *ngIf=" liveAir.SiteId == 78 ">
            <div fxLayout="row" fxLayoutAlign="space-around center" fxLayoutGap="10px">
                <div fxFlex fxFlex.sm="50" fxFlexAlign="center">
                    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="0px">
                        <div fxFlex>
                            <span class="AQI-sitename">{{ liveAir.SiteName }} </span> 
                        </div>
                        <div fxFlex>
                            <div >即時空氣品質資訊</div> 
                        </div>
                    </div> 
                    
                </div>
                <div fxFlex fxFlex.sm="50" fxFlexAlign="center ">
                    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="0px">
                        <div fxFlex class="AQI-status">              
                            <div [ngSwitch]="liveAir?.Status">
                                <ng-template [ngSwitchCase]="'普通'">
                                    <div class="aqi-level aqi-level2"> 
                                        <span>{{ liveAir.Status }}</span>
                                        <span class="AQI">{{ liveAir.AQI }}</span>
                                        
                                    </div>
                                </ng-template>
                                <ng-template [ngSwitchCase]="'對敏感族群不健康'">
                                  <div class="aqi-level aqi-level3"> {{ liveAir.Status }}</div>
                                </ng-template>
                                <ng-template [ngSwitchCase]="'對所有族群不健康'">
                                    <div class="aqi-level aqi-level4"> {{ liveAir.Status }}</div>
                                </ng-template>
                                <ng-template [ngSwitchCase]="'非常不健康'">
                                    <div class="aqi-level aqi-level5"> {{ liveAir.Status }}</div>
                                </ng-template>
                                <ng-template [ngSwitchCase]="'危害'">
                                    <div class="aqi-level aqi-level6"> {{ liveAir.Status }}</div>
                                </ng-template>
                                <ng-template ngSwitchDefault>
                                    <div class="aqi-level aqi-level1"> {{ liveAir.Status }}</div>
                                </ng-template>
                            </div>
                        </div>
                              
                        
                    </div> 
                    
                    
                </div>
                
                <div fxFlex fxHide fxShow.gt-sm fxFlexAlign="center" class="hvr-outline-in">
                    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="0px">
                        <div fxFlex>
                            <span class="AQI-title">細懸浮微粒</span> 
                            <span class="AQI-subtitle">PM2.5 (μg/m³)</span>
                        </div>
                        <div fxFlex>
                            <div class="AQI-value">{{ liveAir['PM2.5'] }}</div> 
                        </div>
                    </div>    
                </div>
                
                <div fxFlex fxHide fxShow.gt-sm fxFlexAlign="center" class="hvr-outline-in">
                    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="0px">
                        <div fxFlex>
                            <span class="AQI-title">懸浮微粒</span> 
                            <span class="AQI-subtitle">PM10 (μg/m³)</span>
                        </div>
                        <div fxFlex>
                            <div class="AQI-value">{{ liveAir.PM10 }}</div> 
                        </div>
                    </div>    
                </div>
                <div fxFlex fxHide fxShow.gt-sm fxFlexAlign="center" class="hvr-outline-in">
                    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="0px">
                        <div fxFlex>
                            <span class="AQI-title">臭氧</span> 
                            <span class="AQI-subtitle">O3 (ppb)</span>
                        </div>
                        <div fxFlex>
                            <div class="AQI-value">{{ liveAir.O3 }}</div> 
                        </div>
                    </div>           
                </div>    
                <div fxFlex fxHide fxShow.gt-sm fxFlexAlign="center" class="hvr-outline-in">
                    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="0px">
                        <div fxFlex>
                            <span class="AQI-title">二氧化硫</span> 
                            <span class="AQI-subtitle">SO2 (ppb)</span>
                        </div>
                        <div fxFlex>
                            <div class="AQI-value">{{ liveAir.SO2 }}</div> 
                        </div>
                    </div>           
                </div> 
                <div fxFlex fxHide fxShow.gt-md fxFlexAlign="center">
                    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="0px">               
                            <div fxFlex>
                                <span class="data-source">行政院環境保護署</span>
                            </div>
                            <div fxFlex>
                                <a class="data-source" href="https://opendata.epa.gov.tw/Data/Contents/AQI/" target="_blank" rel="行政院環境保護署。環境資源資料開放平臺"><div class="">環境資源資料開放平臺</div> </a>
                            </div>
                    </div>           
                </div> 
                
            
            </div>
        </div>
    </div>

